import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    PackageProps,
    LoadPackageById,
    LoadAllowedAccountsForPackage,
    LoadAllAccounts,
    setPackageEdit,
    setPackageSettings,
    setPackageReloadEdit,
    setPackageAllowed,
    setAccountList,
    initPackage,
    initPackageSettings,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"
import Settings from "./settings"

const Edit = ({
    packageId = null,
}: PackageProps) => {
    const packg = useSelector((state: StoreType) => state.package.packageEdit)
    const reloadEdit = useSelector((state: StoreType) => state.package.reloadEdit)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setPackageReloadEdit(false))
        setTimeout(() => {
            dispatch(setPackageReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        setLoadState(PENDING)
        Promise.all([
            LoadAllowedAccountsForPackage(packageId).then((res) => {
                dispatch(setPackageAllowed({ [packageId]: res }))
            }),
            LoadAllAccounts().then((res) => {
                dispatch(setAccountList(res))
            }),
        ]).then(() => {
            if (packageId === 0) {
                dispatch(setPackageEdit(initPackage))
                dispatch(setPackageSettings(initPackageSettings))
                setLoadState(IDLE)
                reload()
            } else {
                LoadPackageById(packageId).then((res) => {
                    dispatch(setPackageEdit(res))
                    dispatch(setPackageSettings(res.settingsParsed))
                    setLoadState(IDLE)
                    reload()
                })
            }
        })
    }, [])

    if (!packg) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {packg.id ? `${lang.editPackage} # ${packg.id}` : lang.addPackage}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form packg={packg} />
                }
                {
                    reloadEdit
                    && <Form packg={packg} />
                }
                <Settings />
            </PageContent>
        </Container>
    )
}
export default Edit
